var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWrench = function SvgWrench(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4378_13543)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.9167 9.90852C7.36155 8.90388 7.13122 7.75195 7.25735 6.61108C7.38348 5.4702 7.8599 4.39641 8.6211 3.5373C9.3823 2.67819 10.3909 2.07594 11.5083 1.81335C12.6257 1.55076 13.797 1.64072 14.8611 2.07085L11.3889 5.83387L11.8802 8.12033L14.1667 8.61165L17.9297 5.13943C18.3599 6.20361 18.4498 7.37489 18.1872 8.49227C17.9246 9.60966 17.3224 10.6183 16.4633 11.3795C15.6042 12.1407 14.5304 12.6171 13.3895 12.7432C12.2486 12.8694 11.0967 12.639 10.092 12.0839L5.22573 17.7262C4.83435 18.1176 4.30353 18.3375 3.75003 18.3375C3.19654 18.3375 2.66572 18.1176 2.27434 17.7262C1.88296 17.3349 1.66309 16.804 1.66309 16.2505C1.66309 15.697 1.88296 15.1662 2.27434 14.7748L7.9167 9.90852Z",
    stroke: "#919191",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4378_13543"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
};
export default SvgWrench;